// extracted by mini-css-extract-plugin
module.exports = {"favoriteStoreContainer":"appLayout_favoriteStoreContainer__23OaP"};